import { Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable()
export class ErrorBannerCloseService {
  private eventErrorBannerClose = new Subject<any>();

  event$ = this.eventErrorBannerClose.asObservable();

  emitEvent(data: any) {
    this.eventErrorBannerClose.next(data);
  }
}



// WEBPACK FOOTER //
// ./src/services/error-banner-close.service.ts